export default function Services() {
  const services = [
    {
      title: 'Food Aid',
      description: 'Our food aid program delivers nutritious meals and essential supplies to communities facing hunger. We operate community kitchens, mobile food banks, and emergency ration distribution across 40 countries.',
      stats: '2.5M+ meals served annually',
      icon: 'ri-restaurant-2-line',
      color: 'bg-orange-50',
      iconColor: 'text-orange-600',
    },
    {
      title: 'Education Support',
      description: 'We build schools, fund scholarships, provide learning materials, and train teachers in underserved regions. Our focus is on breaking the cycle of poverty through quality education.',
      stats: '48,000+ children in school',
      icon: 'ri-graduation-cap-line',
      color: 'bg-amber-50',
      iconColor: 'text-amber-600',
    },
    {
      title: 'Disaster Relief',
      description: 'When disaster strikes, our rapid response teams are on the ground within 48 hours. We provide emergency shelter, clean water, medical aid, and long-term rebuilding support.',
      stats: '120+ disasters responded to',
      icon: 'ri-lifebuoy-line',
      color: 'bg-red-50',
      iconColor: 'text-red-600',
    },
    {
      title: 'Pet Rescue',
      description: 'We rescue abandoned, abused, and injured animals. Our shelters provide veterinary care, rehabilitation, and adoption services to find every animal a loving forever home.',
      stats: '15,000+ animals rescued',
      icon: 'ri-home-heart-line',
      color: 'bg-emerald-50',
      iconColor: 'text-emerald-600',
    },
  ];

  return (
    <div className="overflow-x-hidden">
      <section className="w-full pt-32 pb-20 md:pb-28 bg-warm-50">
        <div className="w-full px-6 md:px-10 lg:px-16">
          <span className="text-brand-600 text-sm font-semibold tracking-wider uppercase mb-4 block">
            Our Programs
          </span>
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6 max-w-3xl">
            Four pillars of impact
          </h1>
          <p className="text-gray-600 text-lg max-w-2xl leading-relaxed">
            Every program we run is designed to create lasting, meaningful change.
            Explore how we are making a difference across the globe.
          </p>
        </div>
      </section>

      <section className="w-full py-20 md:py-28 bg-white">
        <div className="w-full px-6 md:px-10 lg:px-16">
          <div className="space-y-20 md:space-y-28">
            {services.map((service, index) => (
              <div
                key={service.title}
                className={`flex flex-col ${index % 2 === 1 ? 'lg:flex-row-reverse' : 'lg:flex-row'} items-center gap-12 lg:gap-20`}
              >
                <div className={`w-full lg:w-1/2 rounded-3xl ${service.color} p-12 md:p-16 flex items-center justify-center aspect-[4/3]`}>
                  <div className="text-center">
                    <div className={`w-24 h-24 rounded-3xl ${service.color} border border-white/50 flex items-center justify-center mx-auto mb-6 shadow-lg`}>
                      <i className={`${service.icon} ${service.iconColor} text-4xl`}></i>
                    </div>
                    <span className="text-4xl md:text-5xl font-bold text-gray-900">{service.stats}</span>
                  </div>
                </div>
                <div className="w-full lg:w-1/2">
                  <div className={`w-14 h-14 rounded-2xl ${service.color} flex items-center justify-center mb-6`}>
                    <i className={`${service.icon} ${service.iconColor} text-2xl`}></i>
                  </div>
                  <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-5">{service.title}</h2>
                  <p className="text-gray-600 text-lg leading-relaxed mb-8">{service.description}</p>
                  <a href="/donate" className="inline-flex items-center gap-2 text-gray-900 font-semibold hover:text-brand-600 transition-colors">
                    Support this program
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}